<template>
  <div class="footer">
    <q-btn
      class="footer__btn footer__btn_cancel"
      :label="this.cancelBtnText || 'Отмена'"
      v-if="!this.hideCancelBtn"
      no-caps
      @click="() => !this.cancelApproveMode && closePopup()"
      :disable="this.loading"
    >
      <PopupConfirm
        v-if="this.cancelApproveMode"
        :title="this.cancelApproveTitle || 'Подтвердите действие'"
        :approve="this.closePopup"
      />
    </q-btn>
    <q-btn
      :class="['footer__btn footer__btn_submit', {footer__btn_disabled: this.disableSubmit}]"
      :label="this.submitBtnText || 'Сохранить'"
      type="submit"
      no-caps
      v-if="!this.hideSubmitBtn"
      :disable="this.loading || btnLoading || !!this.disableSubmit"
      :loading="this.loading || btnLoading"
      @click="handleSubmit"
    />
  </div>
</template>

<script>
import {appActions} from "@/services/store/modules/app_module/app_actions.js";
import PopupConfirm from "@/components/common/PopupConfirm";

export default {
  name: "CustomModalFooter",
  components: {PopupConfirm},
  props: ["onSubmit", "onCancel", "hideCancelBtn", "cancelBtnText", "hideSubmitBtn", "submitBtnText", "btnLoading", "cancelApproveMode", "cancelApproveTitle", "disableSubmit"],
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async handleSubmit() {
      if(!this.onSubmit) return
      this.loading = true
      await this.onSubmit()
      this.loading = false
    },
    closePopup() {
      if(this.onCancel)
        return this.onCancel()
      this.$store.commit(appActions.closeModal());
    },
  }
}
</script>

<style scoped lang="scss">
// Кнопки модалки: компактные, справа (на телефоне — поровну на всю ширину).
// В окне модалки футер прилипает к низу — см. components/modal/index.vue.
.footer {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-top: 16px;

  &__btn {
    min-height: 34px;
    padding: 0 18px;
    border-radius: var(--ms-radius-sm);
    font-size: 13px;
    font-weight: 600;

    &::before {
      box-shadow: none;
    }

    &_submit {
      background-color: var(--ms-primary);
      color: #fff;
    }

    &_cancel {
      background-color: #fff;
      color: var(--ms-text-secondary);
      border: 1px solid var(--ms-border-input);
    }

    &_disabled {
      background: #c7c7c7 !important;
    }
  }

  @media (max-width: 576px) {
    &__btn {
      flex: 1;
    }
  }
}
</style>
